/** Plano mínimo (Gold) para acesso ao módulo Financeiro. */
export const FINANCE_MINIMUM_PLAN_ID = 3;

export function getStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw || raw === "undefined") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Returns true when the office owner's plan is Gold or Premium.
 * Employees are included via the owner's plan (owner_plan_id from the API).
 */
export function canAccessFinanceModule(user = getStoredUser()) {
  if (!user) return false;
  const planId = Number(user.owner_plan_id ?? user.plan_id);
  return planId >= FINANCE_MINIMUM_PLAN_ID;
}
